<template>
  <v-autocomplete
    :id="id"
    ref="albatrossAutocomplete"
    :placeholder="placeholder"
    :model-value="value"
    :items="items"
    :chips="chips"
    :type="type"
    :loading="loading"
    :item-title="itemTitle"
    :item-value="itemValue"
    :return-object="returnObject"
    :multiple="multiple"
    :prepend-icon="prependIcon"
    :prepend-inner-icon="prependInnerIcon"
    :append-icon="appendInnerIcon"
    :clearable="clearable"
    :menu-props="menuProps"
    v-bind="$attrs"
    :height="height"
    :hint="hint"
    :single-line="singleLine"
    :search.sync="syncSearchInput"
    :rules="combinedRules"
    :readonly="readonly"
    :disabled="disabled"
    :cache-items="cacheItems"
    :hide-details="hideDetails"
    :density="density"
    :color="color"
    :no-data-text="noDataText"
    :item-disabled="itemDisabled"
    :error="error"
    :error-messages="errorMessages"
    :clear-icon="clearIcon || 'mdi-close'"
    :custom-filter="filter"
    :variant="variant"
    :autofocus="autofocus"
    :full-width="fullWidth"
    :persistent-hint="persistentHint"
    :class="[customClasses]"
    autocomplete="autocomplete"
    :label="label"
    :menu="menu"
  >
    <template
      v-for="(_, name) in $slots" v-slot:[name]="slotData" :key="name"
    >
      <slot
        :name="name"
        v-bind="slotData ?? {}"
      />
    </template>

    <!--    <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="data">-->
    <!--        <slot :name="slot" v-bind="data"></slot>-->
    <!--    </template>-->
  </v-autocomplete>
</template>

<script setup>
import { ref, computed } from 'vue'
import constants from '@/helpers/constants'


// reminder that v-model is sugar syntax for :value="value" @input="v => $emit('input', v)"
const basicRequiredRule = ref(constants.BASIC_REQUIRED_RULE)

const props = defineProps({
  id: String,
  value: [String, Number, Object, Array], //object for when return-object, array for when multiple
  items: {
    type: Array,
    default: () => []
  },
  // itemTitle: String, //vuetify3 = item-title, vuetify2 = item-text
  itemTitle: [String, Function], //vuetify3 = item-title, vuetify2 = item-text
  height: [String, Number],
  itemValue: String,
  noDataText: String,
  bgColor: String, //vuetify3 = bg-color, vuetify2 = background-color
  multiple: Boolean,
  returnObject: Boolean,
  autofocus: Boolean,
  fullWidth: Boolean,
  loading: Boolean,
  placeholder: String, //fields without a defined default will default to null
  label: String,
  variant: String,
  hint: String,
  menuProps: [String, Object],
  color: String,
  clearIcon: String,
  prependIcon: String,
  prependInnerIcon: String,
  //vue2's appendIconOuter = appendIcon in vue3
  //vue2's appendIcon = appendInnerIcon in vue3
  appendIcon: String,
  appendInnerIcon: String,
  type: {
    type: String,
    default: 'text'
  },
  rules: {
    type: Array,
    default: () => []
  },
  customClasses: {
    type: String,
    default: ''
  },
  required: Boolean,
  readonly: Boolean,
  disabled: Boolean,
  clearable: Boolean,
  cacheItems: Boolean,
  itemDisabled: String,
  hideNoData: Boolean,
  error: Boolean,
  errorMessages: String,
  searchInput: String,
  filter: Function,
  chips: Boolean,
  hideDetails: Boolean,
  singleLine: Boolean,
  persistentHint: Boolean,
  density: String,
  autocomplete: String,
  menu: {
    type: Boolean,
    default: false
  }
})

const variants = [
  'outlined',
  'plain',
  'underlined',
  'filled',
  'solo',
  'solo-inverted',
  'solo-filled'
]
const variant = computed(() => {
  if (!variants.includes(props.variant)) {
    return 'underlined'
  }
  return props.variant
})

const albatrossAutocomplete = ref(null)

const combinedRules = computed(() => {
  let tempRules = []
  //set the rules to any rules that were passed in
  tempRules = props.rules
  // if the field is marked as "required" also add the basic required rule
  if (props.required) {
    tempRules = tempRules.concat(basicRequiredRule.value)
  }
  return tempRules
})

//i think this makes it work and not complain about changing values in the child..
const syncSearchInput = ref(props.searchInput)

const newFocus = () => {
  albatrossAutocomplete.value.focus()
}

defineExpose({
  focus: newFocus,
})
</script>

<style lang="scss" scoped></style>
